<template>
    <div class="image-component-content"
        @click="rePortImageComponent()">
        <img class="component-image"
            :src="getPicUrl(activityComponentObj && activityComponentObj.jsonField && activityComponentObj.jsonField.picUrl)">
    </div>
</template>

<script>
import utils from '../../../../utils/comUtils.js';
export default {
  components: {},
  props: {
    activityComponentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    activityCode: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      isShow: false,
    };
  },
  created() {},
  methods: {
    // 获取图片地址
    getPicUrl(data) {
      if (data) {
        return this.$utils.getImageUrl(JSON.parse(data).file);
      }
    },
    rePortImageComponent() {
      const params = {
        actionCode: '400070002',
        actionName: '点击图片控件',
        title: '点击图片控件',
      };
      this.goBatchReport(params);
    },
    goBatchReport(data) {
      const params = {
        actionCode: data.actionCode,
        actionName: data.actionName,
        content: {
          title: data.title,
          activityCode: this.activityCode,
        },
      };
      console.log('上报参数',params)
      utils.handleBatchReport(this, params);
    },
  },
};
</script>

<style lang="scss" scoped>
.component-image {
  width: 100%;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/activityManagementComponents/imagesComponent.vue